export const ACCESS_SHARING_EQUIPMENT_STEPS = {
  EQUIPMENT_SELECTION: 0,
  ACCESS_SHARING: 1,
  OVERVIEW: 2,
} as const;
